// extracted by mini-css-extract-plugin
export default {"history-buttons":"lsf-history-buttons","history-buttons__action":"lsf-history-buttons__action","history-buttons__action_delete":"lsf-history-buttons__action_delete"};